var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_639_363",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_1212_6753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40 0.879883H0V40.8799H40V0.879883Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_639_363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1665 22.5469C18.1665 21.7184 17.495 21.0469 16.6665 21.0469C15.8381 21.0469 15.1665 21.7184 15.1665 22.5469V27.5469C15.1665 28.3753 15.8381 29.0469 16.6665 29.0469C17.495 29.0469 18.1665 28.3753 18.1665 27.5469V22.5469Z",
    fill: "#1D2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.333 21.0469C24.1614 21.0469 24.833 21.7184 24.833 22.5469V27.5469C24.833 28.3753 24.1614 29.0469 23.333 29.0469C22.5046 29.0469 21.833 28.3753 21.833 27.5469V22.5469C21.833 21.7184 22.5046 21.0469 23.333 21.0469Z",
    fill: "#1D2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4289 10.0713C16.9025 9.28198 16.6466 8.25822 15.8573 7.78464C15.068 7.31106 14.0442 7.567 13.5706 8.3563L10.0563 14.2136H4.99927C4.07879 14.2136 3.33301 14.9598 3.33301 15.8802C3.33301 16.8007 4.07879 17.5469 4.99927 17.5469H5.12494C5.04645 18.6368 4.99927 19.7585 4.99927 20.8802C4.99927 22.0461 5.05024 23.212 5.13436 24.3422C5.45885 28.7022 5.62109 30.8822 7.80922 33.0703C9.99734 35.2584 12.1773 35.4207 16.5373 35.7452C17.6675 35.8293 18.8334 35.8802 19.9993 35.8802C21.1651 35.8802 22.331 35.8293 23.4612 35.7452C27.8212 35.4207 30.0012 35.2584 32.1893 33.0703C34.3774 30.8822 34.5397 28.7022 34.8642 24.3422C34.9483 23.212 34.9993 22.0461 34.9993 20.8802C34.9993 19.7585 34.9521 18.6368 34.8736 17.5469H34.9993C35.9197 17.5469 36.6663 16.8007 36.6663 15.8802C36.6663 14.9598 35.9197 14.2136 34.9993 14.2136H29.9433L26.4289 8.3563C25.9553 7.567 24.9316 7.31106 24.1423 7.78464C23.353 8.25822 23.097 9.28198 23.5706 10.0713L26.056 14.2136H13.9436L16.4289 10.0713ZM8.46736 17.5469H31.5312L31.54 17.6657C31.6191 18.7276 31.6659 19.8099 31.6659 20.8802C31.6659 21.9506 31.6191 23.0329 31.54 24.0948C31.1989 28.6787 31.0093 29.5363 29.8323 30.7133C28.6553 31.8903 27.7978 32.0799 23.2138 32.421C22.1519 32.5 21.0696 32.5469 19.9993 32.5469C18.9289 32.5469 17.8466 32.5 16.7847 32.421C12.2008 32.0799 11.3432 31.8903 10.1662 30.7133C8.98924 29.5363 8.79966 28.6787 8.4585 24.0948C8.37946 23.0329 8.3326 21.9506 8.3326 20.8802C8.3326 19.8099 8.37946 18.7276 8.4585 17.6657L8.46736 17.5469Z",
    fill: "#1D2023"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/SVG (1).1e6e5a2c21c3377ca07901e922b086a4.svg";
export { ForwardRef as ReactComponent };